import { createFileRoute } from "@tanstack/react-router"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import InvoiceData from "@/components/coreAnalytics/InvoiceData"

function InvoicePage() {
  return (
    <Box>
      <Box sx={{ padding: "30px 30px 0" }}>
        <Typography variant="h3" sx={{ fontWeight: 600 }}>
          Invoice Data
        </Typography>
      </Box>
      <InvoiceData />
    </Box>
  )
}

export const Route = createFileRoute("/core/analytics/invoice")({ component: InvoicePage })
